import {
  adminFeedbackSchema,
  type AdminFeedback,
  type AdminFeedbackAnswerRequest,
} from '@steado/admin-contract/feedback';
import { paginationMetaSchema } from '@steado/admin-contract/pagination';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import type { ApiClient } from '@/lib/api/client';

import type { FeedbackSearch } from './feedback-search';

export const FEEDBACK_PAGE_SIZE = 20;

const feedbackPageSchema = z.object({
  items: z.array(adminFeedbackSchema),
  pagination: paginationMetaSchema,
});
export type FeedbackPage = z.infer<typeof feedbackPageSchema>;

export function feedbackQueryOptions(api: ApiClient, search: FeedbackSearch) {
  const query = {
    status: search.status,
    kind: search.kind,
    cursor: search.cursor,
    limit: FEEDBACK_PAGE_SIZE,
  };
  return queryOptions({
    queryKey: ['admin', 'feedback', query],
    queryFn: async (): Promise<FeedbackPage> => {
      const response = await api.requestWithMeta({
        path: '/admin/feedback',
        query,
        schema: z.array(adminFeedbackSchema),
      });
      return feedbackPageSchema.parse({ items: response.data, pagination: response.meta.pagination });
    },
    placeholderData: (previous) => previous,
  });
}

export function resolveFeedback(
  api: ApiClient,
  id: string,
  body: AdminFeedbackAnswerRequest,
): Promise<AdminFeedback> {
  return api.request({
    path: `/admin/feedback/${id}/resolve`,
    method: 'POST',
    body,
    schema: adminFeedbackSchema,
  });
}

export function dismissFeedback(
  api: ApiClient,
  id: string,
  body: AdminFeedbackAnswerRequest,
): Promise<AdminFeedback> {
  return api.request({
    path: `/admin/feedback/${id}/dismiss`,
    method: 'POST',
    body,
    schema: adminFeedbackSchema,
  });
}
